//region :: Imports ::
import InvokeResult from './InvokeResult';
import MInvokeResult from './InvokeResult';
import MInvokeObjectResult from './InvokeObjectResult';

//endregion

/** */
abstract class MServiceBase {

    /** */
    private static isValidationException(exception: any): boolean {
        return exception.status === 400 && exception.response.errors !== undefined && exception.response.title !== undefined;
    };

    /** */
    public async invoke(action: () => Promise<void>): Promise<InvokeResult> {

        try {

            await action();
            return MInvokeResult.ok();

        } catch(ex: any) {

            if(!MServiceBase.isValidationException(ex)) {
                throw ex;
            }

            return MInvokeResult.notOk(ex);

        }

    }

    /** */
    public async invokeReply<TReply>(action: () => Promise<TReply>): Promise<MInvokeObjectResult<TReply>> {

        try {

            const reply = await action();
            return MInvokeObjectResult.ok(reply);

        } catch(ex: any) {

            if(!MServiceBase.isValidationException(ex)) {
                throw ex;
            }

            return MInvokeObjectResult.notOk(ex);

        }

    }

}

export default MServiceBase;
